{
  "cookies-dialog": {
    "buttons": {
      "accept-all": "Đồng ý tất cả cookies",
      "save": "Lưu cài đặt",
      "setting": "Cài đặt Cookies"
    },
    "text": {
      "title": "Quyền riêng tư và Cookies",
      "content-1": "Chúng tôi sử dụng phân tích (ví dụ: cookie hoặc dấu vân tay) để đo tần suất truy cập trang web của chúng tôi và cách sử dụng trang web đó. Chúng tôi cũng sử dụng nội dung kỹ thuật của bên thứ ba để đơn giản hóa việc kiểm soát thẻ (trình quản lý thẻ).",
      "content-2": "Trong ngữ cảnh này, chúng tôi cũng sử dụng các nhà cung cấp dịch vụ ở các nước thứ ba ngoài EU mà không có mức độ bảo vệ dữ liệu đầy đủ, điều này kéo theo những rủi ro sau: Cơ quan có thẩm quyền truy cập mà không có thông tin, không có quyền của chủ thể dữ liệu, không có biện pháp khắc phục pháp lý, mất kiểm soát.",
      "content-3": "Bạn có thể tìm thêm thông tin về việc sử dụng dữ liệu của mình trong chính sách bảo mật của chúng tôi. Với cài đặt của mình, bạn đồng ý với các quy trình được mô tả ở trên.",
      "essential-cookies": "Thiết yếu",
      "essential-cookies-description": "Cookie thiết yếu kích hoạt các chức năng cơ bản và cần thiết để trang web hoạt động bình thường.",
      "statistics-cookies": "Phân tích & Thống kê",
      "statistics-cookies-description": "Cookie phân tích & thống kê thu thập thông tin ẩn danh. Thông tin này giúp chúng tôi hiểu cách khách truy cập sử dụng trang web của chúng tôi."
    }
  }
}
